import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/components/common';
import { PriceListForm } from '../PriceListForm';
import { CreatePriceListRequest, UpdatePriceListRequest } from '@/types/pricing';
import { pricingApi } from '@/api/endpoints/pricing';
import { useUIStore } from '@/store/uiStore';
import { useToastStore } from '@/store/toastStore';

export const CreatePriceListModal: React.FC = () => {
  const { t } = useTranslation();
  const { modals, closeModal, refreshCallbacks } = useUIStore();
  const { addToast } = useToastStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: CreatePriceListRequest | UpdatePriceListRequest) => {
    setIsLoading(true);
    try {
      // For create modal, we only handle CreatePriceListRequest
      await pricingApi.createPriceList(data as CreatePriceListRequest);
      
      addToast({
        title: t('common.success'),
        type: 'success',
        message: t('pricing.messages.createSuccess'),
      });

      // Trigger refresh in parent component
      refreshCallbacks.priceLists?.();

      closeModal('createPriceList');
      
      // Dispatch custom event to refresh price list
      window.dispatchEvent(new CustomEvent('refreshPriceLists'));
    } catch (error) {
      console.error('Error creating price list:', error);
      addToast({
        title: t('common.error'),
        type: 'error',
        message: error instanceof Error ? error.message : t('common.error'),
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    closeModal('createPriceList');
  };

  if (!modals.createPriceList) {
    return null;
  }

  return (
    <Modal
      isOpen={modals.createPriceList}
      onClose={handleCancel}
      title={t('pricing.create')}
      size="xl"
    >
      <PriceListForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={isLoading}
      />
    </Modal>
  );
}; 